import { AxiosResponse } from 'axios';
import { BaseService } from '../../../../../services/route.service';
import { BoardRequest, BoardUpdateRequest } from './requests/board.request';
import { BoardDetailResponse, BoardResponse, BoardSummaryResponse } from './responses/board.response';

export class CrmBoardService extends BaseService {
    protected get resourceName(): string {
        return 'crm/boards';
    }


    public async getSummaries(): Promise<AxiosResponse<{ data: BoardSummaryResponse[] }>> {
        return await this.get('summaries');
    }

    public async getById(
        id: string,
        includeClosed = false
    ): Promise<AxiosResponse<{ data: BoardDetailResponse }>> {
        return await this.get(id, includeClosed ? { includeClosed: true } : undefined);
    }

    public async create(body: BoardRequest): Promise<AxiosResponse<{ data: BoardResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: BoardUpdateRequest): Promise<AxiosResponse<{ data: BoardResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
